import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="copyright">
        &copy; Copyright <strong><span>Mobiapp</span></strong>. All Rights Reserved
      </div>
      <div className="credits">
        {/* You can add additional credits or links here */}
      </div>
    </footer>
  );
};

export default Footer;
